import { Helpers, Utils } from '../../Core';
import { getCmsDeliveryApi as API } from '../../Apis';
import { mocksService } from './GetCobrandedUsefulPhones.mocks';
import dataFields from '../../Types/CmsCobrandedCard.json';
import { CmsCobrandedUsefulPhones as Internals } from '../../Types/internals';
import { CmsCobrandedUsefulPhonesTypes as Types } from '../../Types';
import {
  dictionaryFactory,
  removeHtmlTags,
  removeHtmlTagsKeepBrTag,
  removeHtmlTagsAndKeepTagsBetweenText,
} from '../../Utils';
import {
  PhoneType,
  UsefulPhonesData,
} from '../../Types/CmsCobrandedUsefulPhones.types';

const prepareCall = async () => {
  const { cmsDeliveryIds } = Helpers.getConstants();
  const { USEFUL_PHONES } = cmsDeliveryIds as {
    [key: string]: string;
  };

  return API.call.get({
    contentId: USEFUL_PHONES,
  });
};

const bankTypeDictionary = dictionaryFactory({
  bb: 'BB',
  bradesco: 'BRADESCO',
  santander: 'SANTANDER',
}) as Record<string, Types.CobrandedBanksType>;

const formmattedPhones = (phonesToFormat: string): PhoneType[] => {
  const titles = phonesToFormat
    .match(/<strong>(.+?)<\/strong>/g)
    ?.map((item) => {
      return removeHtmlTags(item).trim();
    });
  const phones = phonesToFormat
    .match(/<\/strong>(.*?)<strong>|<\/strong>(?!.*<\/strong>).+/g)
    ?.map((item) => {
      return removeHtmlTagsAndKeepTagsBetweenText(
        removeHtmlTagsKeepBrTag(item),
      ).trim();
    });

  const formmatted: PhoneType[] = [];

  titles?.forEach((title, index) => {
    formmatted.push({
      title: title,
      text: phones?.[index] ?? '',
    });
  });

  return formmatted;
};

const getPhoneList = (
  bankName: Internals.CobrandedBanksType,
  content: Record<string, string>,
) => {
  const bankPhones = content[`${bankName}tel`];
  const bank = formmattedPhones(bankPhones);

  const smilesBankPhones = content[`${bankName}smiles`];
  const smiles = formmattedPhones(smilesBankPhones);

  return {
    bank,
    smiles,
  };
};

const handleSucessFinalResponseFunction = (
  result: Internals.GetCobrandedUsefulPhonesServiceResponse,
): UsefulPhonesData => {
  const contents = Object.entries(result.content);
  const banksPhones: Types.UsefulPhonesData = [];

  contents.forEach((item) => {
    const bank = item[0] as Internals.CobrandedBanksType;
    const content = item[1].content;
    banksPhones.push({
      type: bankTypeDictionary[bank],
      phoneList: getPhoneList(bank, content),
    });
  });

  return banksPhones;
};

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction: prepareCall,
  definitionsAPI: API.definitions,
  handleResponse: { handleSucessFinalResponseFunction },
  mocksService,
  dataFields,
});
